export default {
  hero_badge: 'Organized resources · Guides · Regularly updated',
  hero_title: 'USFans Spreadsheet — Find, Explore & Organize Creator Information',
  hero_subtitle: 'Explore a structured USFans Spreadsheet with creator resources, useful guides, comparisons, reviews, shipping information and safety tips — all in one easy-to-use hub.',
  hero_primary_cta: 'Explore USFans Spreadsheet',
  hero_secondary_cta: 'Browse Creator Resources',
  hero_dropdown_label: 'Choose a category to start browsing',
  hero_dropdown_placeholder: 'Select a category…',
  btn_spreadsheet: 'usfans spreadsheet',
  btn_buy_now: 'buy it now',
  categories_title: 'Browse Product Categories',
  categories_subtitle: 'Pick a category below to jump straight to the matching products on the main website. Every link opens in a new tab so you can come back here anytime.',
  category_shoes: 'Shoes',
  category_hoodies: 'Hoodies/Sweaters',
  category_tshirts: 'T-Shirts',
  category_jackets: 'Jackets',
  category_pants: 'Pants/Shorts',
  category_headwear: 'Headwear',
  category_sets: 'Sets',
  category_underwear: 'Underwear/Underpants',
  category_jersey: 'Jersey',
  category_accessories: 'Accessories',
  category_bags: 'Bags',
  category_belts: 'Belts',
  category_perfumes: 'Perfumes',
  category_other: 'Other Stuff',
  about_title: 'What is the USFans Spreadsheet?',
  about_p1: 'The USFans Spreadsheet is a simple, organized way to browse USFans-related products and creator information. Instead of searching through scattered pages one by one, everything is grouped into clear categories — from Shoes and Hoodies to Bags, Belts and Perfumes — so you can find what you are looking for faster.',
  about_p2: 'Our goal is to make information easier to understand. We collect helpful guides, comparisons and safety tips in one place, then connect you to the main website where the full product range lives. We are an independent resource, not the official USFans website.',
  about_p3: 'Whether you are exploring for the first time or comparing options before you buy, the spreadsheet gives you a clean starting point. Use the category buttons or the dropdown above to jump straight to the products you care about.',
  article_section_title: 'USFans Guides, Reviews & Tips',
  article_section_subtitle: 'Explore our library of in-depth USFans articles covering spreadsheets, reviews, shipping, deals, safety and more.',
  article_card_title: 'What Is a USFans Spreadsheet?',
  article_card_excerpt: 'A complete beginner-friendly guide covering what a USFans Spreadsheet is, what you can find inside it, and how to use it to browse creator and product information safely.',
  article_read_more: 'Read the full guide',
  cta_title: 'Ready to explore the full range?',
  cta_text: 'Browse organized categories and guides here, then visit the main website to see the complete product selection.',
  cta_primary: 'Visit Main Website',
  cta_secondary: 'Explore USFans Spreadsheet',
};